/* eslint-disable no-unused-vars */
import { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Title, Button, SimpleGrid } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import AppContext from './Context/index';

const PaymentStatus = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [buttonText, setButtonText] = useState();
  const appContextState = useContext(AppContext);
  const { appState, setAppState } = appContextState;
  // const { t, i18n } = useTranslation();

  useEffect(() => {
    if (appState?.language === 'ar') {
      setButtonText('English');
    } else if (appState?.language === 'en') {
      setButtonText('Arabic');
    }
  }, [appState?.language]);

  const changeLanguageHandler = () => {
    // const languageValue = language;
    // i18n.changeLanguage(languageValue);
    // if (buttonText === 'Arabic') {
    //   setButtonText('English');
    // } else if (buttonText === 'English') {
    //   setButtonText('Arabic');
    // }
    // if (language === 'ar') {
    //   setLanguage('en');
    // } else if (language === 'en') {
    //   setLanguage('ar');
    // }
    setAppState(appState);
    if (appState?.language === 'ar') {
      setAppState({ language: 'en' });
    } else if (appState?.language === 'en') {
      setAppState({ language: 'ar' });
    }
    if (appState?.language === 'en') {
      setButtonText('English');
    } else if (appState?.language === 'ar') {
      setButtonText('Arabic');
    }
  };

  return (
    <SimpleGrid cols={4} position="apart" px="xl" className="no-printme">
      <Button
        color="blue"
        radius="md"
        size="xl"
        style={{
          width: appState?.language === 'en' ? '200px' : '300px',
          height: '70px',
          backgroundColor: '#4D6D78',
          position: 'fixed',
          left: 100,
          bottom: 55,
        }}
        onClick={changeLanguageHandler}
      >
        {buttonText === 'Arabic' ? <Title order={1}>عربي</Title> : <Title order={1}>English</Title>}
      </Button>
      <div />
      <div />
      <Button
        onClick={() => navigate('/')}
        color="blue"
        radius="md"
        size="xl"
        style={{
          width: appState?.language === 'en' ? '200px' : '300px',
          height: '70px',
          backgroundColor: '#4D6D78',
          position: 'fixed',
          right: 100,
          bottom: 55,
        }}
      >
        <Title order={1}>{t('return.to.home.button.text')}</Title>
      </Button>
    </SimpleGrid>
  );
};
export default PaymentStatus;
